import { v4 as uuidv4 } from 'uuid';

export const addTodo = (data)=>{
    return{
        type : "ADD_TODO",
        payload : {
            // id : new Date().getDate().toString(),
            id : uuidv4(),
            data : data
        }
    }
}

export const deleteTodo = (id)=>{
    return{
        type : "DELETE_TODO",
        id
    }
}

export const removeTodo = ()=>{
    return{
        type : "REMOVE_TODO"
    }
}